import React, { useEffect, useState } from "react";

function SecurityScanPage({ goToPage }) {
  const [confirmedFiles, setConfirmedFiles] = useState([]);
  const [bundles, setBundles] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [scanInput, setScanInput] = useState("");
  const [status, setStatus] = useState("");
  const [allScanned, setAllScanned] = useState(false);
  const [currentStore, setCurrentStore] = useState("");

  // Fetch confirmed files from logs
  useEffect(() => {
  fetch(`${process.env.REACT_APP_API_URL}/api/log/list`)
    .then((res) => res.json())
    .then((data) => {
      const confirmed = data
        .filter((log) => log.includes("|CONFIRMED|"))
        .map((log) => log.split("|")[0]);

      const validated = data
        .filter((log) => log.includes("|VALIDATED|"))
        .map((log) => log.split("|")[0]);

      // Exclude validated files
      const available = confirmed.filter((f) => !validated.includes(f));

      setConfirmedFiles([...new Set(available)]);
    });
}, []);

  // Load selected validation file
  // Load selected validation file
const loadValidationFile = (file) => {
  setSelectedFile(file);

  fetch(
    `${process.env.REACT_APP_API_URL}/api/file-data?fileName=` + file
  )
    .then((res) => res.json())
    .then((data) => {

      // ================================
      // GET STORE NAME FROM CSV
      // A1 = Store Name:
      // B1 = Actual Store
      // ================================
      let fileStoreName = "";

      if (data.length > 0) {
        const firstRow = data[0].split(",");

        // Example:
        // ["Store Name:", "TAMBARAM"]
        fileStoreName = (firstRow[1] || "").trim();
      }

      // ================================
      // PARSE TABLE DATA
      // ================================
      const parsedBundles = data
        .map((row) => row.split(","))

        // remove empty rows
        .filter((row) => row.length > 1)

        // remove header rows
        .filter(
          (row) =>
            row[0] !== "Store Name:" &&
            row[0] !== "Tag No:" &&
            row[0] !== "S.No"
        )

        // valid rows only
        .filter((row) => row.length >= 7)

        .map((row, index) => ({
          serial: index + 1,

          // use store from B1
          storeName: fileStoreName,

          // actual table values
          STO: row[1]?.trim(),
          Category: row[2]?.trim(),
          RPN: row[3]?.trim(),

          total: parseInt(row[4], 10),

          scannedBundles: [],
        }));

      setBundles(parsedBundles);

      // IMPORTANT RESETS
      setCurrentStore(fileStoreName);
      setStatus("");
      setAllScanned(false);
      setScanInput("");
    })
    .catch((err) => {
      console.error(err);
      alert("Failed to load validation file");
    });
};
  // Handle QR scan input
  const handleScan = (e) => {
  if (e.key === "Enter") {
    const qr = scanInput.trim();
    if (!qr) return;

    const parts = qr.split("|");

    if (parts.length < 6) {
      setStatus("❌ Invalid QR Format");
      setScanInput("");
      return;
    }

    // ✅ FULL PARSE (IMPORTANT FIX)
    const [storeName, bundleInfo, STO, category, qtyVal, RPN] = parts;
    const [bundleNo, totalBundles] = bundleInfo.split("/").map(Number);

    // ❌ Validate bundle number
    if (bundleNo > totalBundles || bundleNo <= 0) {
      setStatus(`❌ Invalid bundle number ${bundleNo}/${totalBundles}`);
      setScanInput("");
      return;
    }

    // ✅ Find exact matching bundle (STO + Category + RPN)
    const found = bundles.find(
      (b) =>
        b.STO === STO &&
        b.Category === category &&
        b.RPN === RPN
    );

    if (!found) {
      setStatus("❌ No matching STO / Category / RPN found");
    } 
    else if (found.total !== totalBundles) {
      setStatus("❌ Total bundle mismatch");
    }
    else if (found.scannedBundles.includes(bundleNo)) {
      setStatus(`⚠️ Bundle ${bundleNo}/${found.total} already scanned`);
    } 
    else {

  // First scanned QR decides store
  if (!currentStore) {
    setCurrentStore(storeName);
  }

  // Reject different store QR
  if (
    currentStore &&
    currentStore.trim().toUpperCase() !==
      storeName.trim().toUpperCase()
  ) {
    setStatus(`❌ Wrong Store QR (${storeName})`);
    setScanInput("");
    return;
  }

  found.scannedBundles.push(bundleNo);

  setBundles([...bundles]);

  setStatus(
    `✅ Bundle scanned (${found.scannedBundles.length}/${found.total})`
  );

  const allDone = bundles.every(
    (b) => b.scannedBundles.length >= b.total
  );

  setAllScanned(allDone);
}

    setScanInput("");
  }
};
  const totalBundles = bundles.reduce((acc, b) => acc + b.total, 0);
  const totalScanned = bundles.reduce((acc, b) => acc + b.scannedBundles.length, 0);
  const remaining = totalBundles - totalScanned;

  // Submit fully scanned file as validated
  const submitValidation = () => {
  if (!selectedFile) return;
  if (!allScanned) {
    alert("All bundles must be scanned before submitting!");
    return;
  }

  fetch(`${process.env.REACT_APP_API_URL}/api/files/submit-validation?fileName=` + selectedFile, {
    method: "POST",
  })
    .then((res) => res.text())
    .then((msg) => {
      if (msg === "Validated") {
        alert(`✅ File ${selectedFile} marked as validated!`);

        // Clear local selection
        setSelectedFile("");
        setBundles([]);
        setAllScanned(" ");

        // Refresh confirmed files dropdown
        fetch(`${process.env.REACT_APP_API_URL}/api/log/list`)
          .then((res) => res.json())
          .then((data) => {
            const confirmed = data
              .filter((log) => log.includes("|CONFIRMED|"))
              .map((log) => log.split("|")[0]);

            // Exclude validated files
            const validated = data
              .filter((log) => log.includes("|VALIDATED|"))
              .map((log) => log.split("|")[0]);

            setConfirmedFiles(
              [...new Set(confirmed)].filter((f) => !validated.includes(f))
            );
          });
      } else {
        alert("❌ Something went wrong. Try again.");
      }
    });
};


  return (
    <div style={{ padding: "15px", maxWidth: "1000px", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
        <h2 style={{ flex: "1 1 auto", minWidth: "200px" }}>Security QR Validation</h2>
        <button style={{ flex: "0 0 auto" }} onClick={() => goToPage("dashboard")}>⬅ Back</button>
      </div>
      <hr />

      {/* Report Selection */}
      <div style={{ marginBottom: "20px" }}>
        <label style={{ fontWeight: "bold", marginRight: "10px" }}>Select Report:</label>
        <select
          value={selectedFile}
          onChange={(e) => loadValidationFile(e.target.value)}
          style={{ padding: "8px 12px", fontSize: "16px", width: "100%", maxWidth: "400px", marginTop: "5px" }}
        >
          <option value="">-- Choose a report --</option>
          {confirmedFiles.map((file, i) => (
            <option key={i} value={file}>{file}</option>
          ))}
        </select>
      </div>

      {selectedFile && (
        <>
          {/* Scan Input */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <input
              value={scanInput}
              onChange={(e) => setScanInput(e.target.value)}
              onKeyDown={handleScan}
              placeholder="Scan QR Bundle Here"
              autoFocus
              style={{ width: "100%", maxWidth: "500px", padding: "15px", fontSize: "18px", borderRadius: "8px", border: "1px solid #ccc", textAlign: "center" }}
            />
            <div style={{ marginTop: "10px", fontSize: "16px", fontWeight: "bold", wordBreak: "break-word" }}>
              {status}
            </div>
          </div>

          {/* Counters */}
          <div style={{ display: "flex", justifyContent: "space-around", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
            <div style={{ padding: "10px 15px", background: "#f0f0f0", borderRadius: "6px", flex: "1 1 30%", textAlign: "center" }}>
              <strong>Total:</strong> {totalBundles}
            </div>
            <div style={{ padding: "10px 15px", background: "#d4edda", borderRadius: "6px", flex: "1 1 30%", textAlign: "center" }}>
              <strong>Scanned:</strong> {totalScanned}
            </div>
            <div style={{ padding: "10px 15px", background: "#f8d7da", borderRadius: "6px", flex: "1 1 30%", textAlign: "center" }}>
              <strong>Remaining:</strong> {remaining}
            </div>
          </div>

          {/* Submit Button */}
          {allScanned && (
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <button
                onClick={submitValidation}
                style={{ padding: "12px 20px", fontSize: "16px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer" }}
              >
                ✅ Submit Validated File
              </button>
            </div>
          )}

          {/* Scrollable Bundle Table */}
          <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto", border: "1px solid #ccc", borderRadius: "6px" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
              <thead style={{ position: "sticky", top: 0, backgroundColor: "#f0f0f0", zIndex: 1 }}>
                <tr>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>S.No</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>STO</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>Category</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>RPN</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>Total</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>Scanned</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {bundles.map((b, idx) => (
                  <tr key={idx} style={{ backgroundColor: b.scannedBundles.length >= b.total ? "#d4edda" : "#f8d7da" }}>
                    <td style={{ padding: "8px", textAlign: "center" }}>{b.serial}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>{b.STO}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>{b.Category}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>{b.RPN}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>{b.total}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>{b.scannedBundles.length}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      {b.scannedBundles.length >= b.total ? "✅ Complete" : `${b.scannedBundles.length}/${b.total} scanned`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default SecurityScanPage;
